import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { AppConfig } from '@tmhcc-ng-lib/models';
import { HttpOptions } from '@tmhcc-ng-lib/framwork/http';
import { throwError } from 'rxjs/internal/observable/throwError';

export abstract class BaseContentService<T> {
  protected config: AppConfig;
  protected serviceBaseUrl: string;

  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    protected t: T
  ) {
    this.config = configService.config;
    this.serviceBaseUrl = `${configService.config.contentServiceBaseUrl}?PageName=`;
    this.staticData = t;
    this.data = t;
  }

  protected loaded = false;
  protected staticData: T;
  protected data: T;
  protected get data$(): Observable<T> {
    return null;
  }

  protected get<T>(url: string, options?: HttpOptions): Observable<T> {
    return this.http.get<T>(url, options);
  }

  protected handleError(err) {
    return throwError(err);
  }
}
